
      import API from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/@rsbuild/core/compiled/css-loader/index.js??clonedRuleSet-6.use[1]!../../../node_modules/rspack-vue-loader/dist/stylePostLoader.js!../../../node_modules/@rsbuild/core/compiled/postcss-loader/index.js??clonedRuleSet-6.use[2]!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ReviewDetails.vue?vue&type=style&index=0&id=06b17086&scoped=true&lang=css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/@rsbuild/core/compiled/css-loader/index.js??clonedRuleSet-6.use[1]!../../../node_modules/rspack-vue-loader/dist/stylePostLoader.js!../../../node_modules/@rsbuild/core/compiled/postcss-loader/index.js??clonedRuleSet-6.use[2]!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ReviewDetails.vue?vue&type=style&index=0&id=06b17086&scoped=true&lang=css";
       export default content && content.locals ? content.locals : undefined;
